// extracted by mini-css-extract-plugin
module.exports = {"container":"Experience_container__mmT9o","description":"Experience_description__2uHU-","infoBlock":"Experience_infoBlock__x4kUD","list":"Experience_list__M3SUP"};